export enum NavigationRoutes {
  InstitutionSettings = "/institution_settings",
  InstitutionSettingsV2 = "/configuration/institution_settings",

  RiskManager = "/risk",
  RiskRules = "/rules",
  TestNotifications = "/test_notification",
  TestCoreConnectivity = "/test_connectivity",
  NotificationHistory = "/notification_history",
  NarmiAdmin = "/narmiadmin",
  Preburner = "/preburner",
  SSO = "/sso",

  Conversions = "/conversions",
  ConversionDataViewer = "/conversions/import_job_units",
  ConversionPortalHome = "/conversion_portal/home",
  ConversionPortalExclusions = "/conversion_portal/exclusions",
  ConversionPortalIssues = "/conversion_portal/issues",
  ConversionPortalUsers = "/conversion_portal/users",
  Deconversions = "/deconversions",

  CopyEditor = "/translations",
  CopyEditorSettings = "/translations/fi",
  CopyEditorServer = "/translations/server",
  CopyEditorOlb = "/translations/olb",
  CopyEditorCao = "/translations/cao",
  CopyEditorBao = "/translations/bao",
  CopyEditorSao = "/translations/sao",
  CopyEditorApp = "/translations/app",
  CopyEditorLending = "/translations/lending",

  Dashboard = "/",

  Inbox = "/inbox",

  DepositApplications = "/applications/deposits",
  LoanApplications = "/applications/loans",
  MembershipCardUploads = "/applications/membership_card_uploads",
  ProductListManager = "/product_list_manager",
  ProductListManagerV2 = "/product_list_manager_v2",
  Personas = "/personas",

  ManageUsers = "/users",
  StaffBulkUpload = "/staff/add_staff/bulk",
  ManageRoles = "/roles",

  ACHManager = "/ach_manager/db",
  AOAchManager = "/ach_manager/ao", // delete AOAchManager logic once new ACH Manager is in GA
  PaymentsAchManager = "/ach_manager/payments",
  PassthruAchManager = "/ach_manager/passthru",
  WireManager = "/wire_manager",
  IntlWireManager = "/international_wires",
  FedNowManager = "/fednow",

  Messages = "/messages",

  Reports = "/analytics",

  Promotions = "/promotions",

  Apps = "/naf",
  OauthApps = "/oauth_apps",
  Functions = "/functions",

  ManageStaff = "/staff",

  Guides = "/guides",

  Guard = "/guard",

  MessagesConfiguration = "/configuration/messages",
  ApplicationsConfiguration = "/configuration/applications",
  SftpWizard = "/configuration/sftp_wizard",
  SettingsSync = "/configuration/sync_settings",

  Survey = "/survey",
  Audiences = "/audiences",
  WireFxRates = "/wire_fx_rates",
}
